/**
 * Which shell the operator sees. Not a setting and not a mode: it follows from the
 * route. Workspace, App and Bulk Run navigate by Apps, and an Experiment navigates
 * by progress, so entering one switches the chrome on its own.
 */
export type Chrome = 'atlas' | 'journey';

export const EXPERIMENT_PREFIX = '/experiments/';

export function chromeForPath(pathname: string): Chrome {
  return pathname === '/experiments' || pathname.startsWith(EXPERIMENT_PREFIX) ? 'journey' : 'atlas';
}

export interface JourneyStage {
  readonly key: string;
  readonly label: string;
}

/** The six stages of an Experiment, in order. */
export const JOURNEY_STAGES: readonly JourneyStage[] = [
  { key: 'brief', label: 'Brief' },
  { key: 'explore', label: 'Explore' },
  { key: 'refine', label: 'Refine' },
  { key: 'compare', label: 'Compare' },
  { key: 'export', label: 'Export' },
  { key: 'learn', label: 'Learn' },
];

export function experimentIdFromPath(pathname: string): string | null {
  if (!pathname.startsWith(EXPERIMENT_PREFIX)) return null;
  const rest = pathname.slice(EXPERIMENT_PREFIX.length).split('/');
  return rest[0] !== undefined && rest[0] !== '' ? rest[0] : null;
}

export function stageFromPath(pathname: string): string {
  const rest = pathname.startsWith(EXPERIMENT_PREFIX) ? pathname.slice(EXPERIMENT_PREFIX.length).split('/') : [];
  const stage = rest[1];
  return stage !== undefined && JOURNEY_STAGES.some((entry) => entry.key === stage) ? stage : 'brief';
}
